module.exports = __webpack_public_path__ + "img/fc-dynamo-kyiv.bd067883.png";